module.exports = __webpack_public_path__ + "static/jorisvoorn_1-b5aaf52959a95d83452e7f5f1b538ea3.jpg";